// extracted by mini-css-extract-plugin
export default {"CustomCheckbox":"c75E1G5HfqFH2QlN8h8S"};